import { STATUS } from '../../../../redux/constants';

export function passwordValidator(setRequirements) {
  return {
    validator(rule, value) {
      let valid = true;
      if (value.length < 8) {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['length'] };
          requirement.status = STATUS.ERROR;
          return {
            ...prevRequirements,
            length: requirement,
          };
        });
        valid = false;
      } else {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['length'] };
          requirement.status = STATUS.SUCCESS;
          return {
            ...prevRequirements,
            length: requirement,
          };
        });
      }
      if (value.toUpperCase() === value) {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_lower_char'] };
          requirement.status = STATUS.ERROR;
          return {
            ...prevRequirements,
            '1_lower_char': requirement,
          };
        });
        valid = false;
      } else {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_lower_char'] };
          requirement.status = STATUS.SUCCESS;
          return {
            ...prevRequirements,
            '1_lower_char': requirement,
          };
        });
      }
      if (value.toLowerCase() === value) {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_upper_char'] };
          requirement.status = STATUS.ERROR;
          return {
            ...prevRequirements,
            '1_upper_char': requirement,
          };
        });
        valid = false;
      } else {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_upper_char'] };
          requirement.status = STATUS.SUCCESS;
          return {
            ...prevRequirements,
            '1_upper_char': requirement,
          };
        });
      }
      const specialChars = '#?!_@$%^&*-';
      if (!value.split('').some((x) => specialChars.includes(x))) {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_special_char'] };
          requirement.status = STATUS.ERROR;
          return {
            ...prevRequirements,
            '1_special_char': requirement,
          };
        });
        valid = false;
      } else {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_special_char'] };
          requirement.status = STATUS.SUCCESS;
          return {
            ...prevRequirements,
            '1_special_char': requirement,
          };
        });
      }
      const digits = '0123456789';
      if (!value.split('').some((x) => digits.includes(x))) {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_digit_char'] };
          requirement.status = STATUS.ERROR;
          return {
            ...prevRequirements,
            '1_digit_char': requirement,
          };
        });
        valid = false;
      } else {
        setRequirements((prevRequirements) => {
          const requirement = { ...prevRequirements['1_digit_char'] };
          requirement.status = STATUS.SUCCESS;
          return {
            ...prevRequirements,
            '1_digit_char': requirement,
          };
        });
      }
      if (valid) return Promise.resolve();
      return Promise.reject();
    },
  };
}
